(function () {
  var DRAG = 1.25;
  var DECAY = 0.9;
  var MIN_VEL = 0.03;

  function bind(root) {
    var viewport = root.querySelector(".iutd-filmstrip__viewport");
    var track = root.querySelector(".iutd-filmstrip__track");
    if (!viewport || !track || root.getAttribute("data-film-bound") === "true") return;
    root.setAttribute("data-film-bound", "true");
    root.classList.add("is-scrub");

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var dir = root.getAttribute("data-direction") === "right" ? 1 : -1;
    var seconds = parseFloat(getComputedStyle(root).getPropertyValue("--film-speed")) || 40;
    var x = 0;
    var loop = 0;
    var dragging = false;
    var lastX = 0;
    var lastT = 0;
    var vel = 0;
    var moved = false;
    var hover = false;

    function measure() {
      var group = track.querySelector(".iutd-filmstrip__group");
      loop = group ? group.offsetWidth : track.scrollWidth / 2;
    }

    function wrap() {
      if (!loop) return;
      while (x <= -loop) x += loop;
      while (x > 0) x -= loop;
    }

    function apply() {
      wrap();
      track.style.transform = "translate3d(" + x + "px,0,0)";
    }

    function auto(dt) {
      if (!loop || reduce) return 0;
      if (root.classList.contains("is-pausable") && hover && !dragging) return 0;
      return ((loop / (seconds * 1000)) * dir) * dt;
    }

    function tick(now) {
      var dt = lastT ? Math.min(32, now - lastT) : 16;
      lastT = now;
      if (!dragging) {
        if (Math.abs(vel) > MIN_VEL) {
          x += vel * dt;
          vel *= DECAY;
        } else {
          vel = 0;
          x += auto(dt);
        }
        apply();
      }
      requestAnimationFrame(tick);
    }

    function down(event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      dragging = true;
      moved = false;
      lastX = event.clientX;
      lastT = event.timeStamp || performance.now();
      vel = 0;
      if (viewport.setPointerCapture) viewport.setPointerCapture(event.pointerId);
      root.classList.add("is-dragging");
    }

    function move(event) {
      if (!dragging) return;
      var now = event.timeStamp || performance.now();
      var dx = event.clientX - lastX;
      var dt = Math.max(1, now - lastT);
      if (Math.abs(dx) > 2) moved = true;
      var step = dx * DRAG;
      x += step;
      vel = step / dt;
      lastX = event.clientX;
      lastT = now;
      apply();
      if (moved) event.preventDefault();
    }

    function up() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove("is-dragging");
    }

    function click(event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }

    viewport.addEventListener("pointerdown", down);
    viewport.addEventListener("pointermove", move, { passive: false });
    viewport.addEventListener("pointerup", up);
    viewport.addEventListener("pointercancel", up);
    viewport.addEventListener("lostpointercapture", up);
    viewport.addEventListener("click", click, true);
    viewport.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });
    root.addEventListener("mouseenter", function () {
      hover = true;
    });
    root.addEventListener("mouseleave", function () {
      hover = false;
    });
    window.addEventListener("resize", function () {
      measure();
      apply();
    });

    measure();
    apply();
    requestAnimationFrame(tick);
  }

  function init() {
    document.querySelectorAll("[data-section-type='iutd-photo-marquee']").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
